import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Logout extends Component {

    constructor(props) {
        super(props);
        this.props = props
        this.handleLogout = this.handleLogout.bind(this)
    }
    
    render() { 
        return (
            <div className="logout-wrapper">
                <div className="logout-button">
                    <a onClick={this.handleLogout}>
                        Log out
                </a>
                </div>
            </div>
        )
    }
    
    handleLogout() {
        localStorage.removeItem("expiry")
        localStorage.removeItem("uid")
        localStorage.removeItem("client")
        localStorage.removeItem("accessToken")
        localStorage.removeItem("user_id")
        this.props.history.push('/')
        }

}
Logout.propTypes = {
    history: PropTypes.object
};

export default Logout;


// WEBPACK FOOTER //
// ./src/components/button/logout.js